import * as React from 'react'

// interface ScriptLoadedState {
//   scriptLoaded: boolean
// }

// interface ScriptLoadedProps {
//   children: React.ReactChild | React.ReactChildren | Function
// }

function SpanIntro() {
	return (
		<span>
			<a href='#section-introduction'>Enter API Key</a> to see examples
		</span>
	)
}

class ScriptLoaded extends React.Component {
	interval;

	constructor(props) {
		super(props)

		this.state = {
			scriptLoaded: !!window.google,
		}

		this.interval = window.setInterval(this.checkIfScriptLoaded, 200)
	}

	setScriptLoadedCallback = () => {
		if (this.state.scriptLoaded) {
			window.clearInterval(this.interval)
		}
	}

	checkIfScriptLoaded = () => {
		if (window.google) {
			this.setState(function serScriptLoaded() {
				return {
					scriptLoaded: true,
				}
			}, this.setScriptLoadedCallback)
		}
	}

	componentWillUnmount() {
		window.clearInterval(this.interval)
	}

	render() {
		if (!this.state.scriptLoaded) {
			return <SpanIntro />
		}

		return this.props.children instanceof Function ? this.props.children() : this.props.children
	}
}

export default ScriptLoaded